module.exports = __webpack_public_path__ + "static/img/vantage-launch.46196d5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/main/vantage-launch.png
// module id = 9s6n
// module chunks = 0